export default "__VITE_ASSET__Dzkzoakj__"